









import { Component, Vue, Prop } from "vue-property-decorator";
import {IndieLogin} from '../services/indie-login';

@Component({
    components: {}
})
export default class ThankYou extends Vue {
    public indieLogin: IndieLogin;

    constructor(){
        super()
        this.indieLogin = new IndieLogin();
    }
}



